var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button dfr cross-center",class:[
    _vm.left ? 'main-start' : '',
    _vm.right ? 'main-end' : '',
    _vm.center ? 'main-center' : ''
  ],style:(("border:" + _vm.border + ";width:" + _vm.width + "; height:" + _vm.height + ";border-radius: " + _vm.borderRadius + "; background: " + (_vm.disabled ? _vm.disabledBackground : _vm.background) + ";font-size:" + _vm.fontSize + ";color:" + (_vm.disabled ? _vm.disabledColor : _vm.color) + ";")),attrs:{"disabled":_vm.disabled},on:{"click":_vm.clickHandle}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }